const MAX_VISIBLE_PAGES = 5;

// Sliding window of up to five page numbers centered on the current page.
export function generatePageNumbers(
  currentPage: number,
  totalPages: number
): number[] {
  if (totalPages <= MAX_VISIBLE_PAGES) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (currentPage <= 3) {
    return Array.from({ length: MAX_VISIBLE_PAGES }, (_, i) => i + 1);
  }

  if (currentPage >= totalPages - 2) {
    return Array.from(
      { length: MAX_VISIBLE_PAGES },
      (_, i) => totalPages - 4 + i
    );
  }

  return Array.from(
    { length: MAX_VISIBLE_PAGES },
    (_, i) => currentPage - 2 + i
  );
}
